module.exports = __webpack_public_path__ + "img/failed-extract-icon.ce70de87.png";